import { Component, OnInit } from '@angular/core';
import { TogglService } from '../toggl.service';
import { TogglUserMatch } from '../toggl.types';

@Component({
    templateUrl: './toggl-user-match.component.html',
    styleUrls: ['./toggl-user-match.component.scss']
})
export class TogglUserMatchComponent implements OnInit {
    constructor(private togglService: TogglService) { }
    
    users: TogglUserMatch[] = [];

    ngOnInit(): void {
        this.togglService.matchUsers().subscribe({
            next: (r) => {
                console.log(r);
                this.users = r.users;
            }
        });
    }

    onUpdateUsers() {
        console.log('Updating users');
        this.togglService.updateUsers().subscribe({
            next: (r) => {
                console.log(r);
                this.users = r.users;
            }
        });
    }

    onResetUsers() {
        console.log('Resetting users');
        this.togglService.resetUsers().subscribe({
            next: (r) => {
                console.log(r);
                this.users = r.users;
            }
        });
    }
    
}